export const smoothTransition = {
  transitionDuration: '300ms',
  transitionProperty: 'all',
  transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)'
}